import { createFileRoute } from "@tanstack/react-router";
import { PlatformPage } from "@/components/PlatformPage";
import { logistykaKurierzy } from "@/lib/integrations-data";
import { buildSeoMeta } from "@/lib/seo";

const PATH = "/integracje/logistyka-kurierzy";

export const Route = createFileRoute("/integracje/logistyka-kurierzy")({
  head: () =>
    buildSeoMeta({
      title: "Integracja kurierów: InPost, DPD, DHL, GLS, Pocztex | SyncTech",
      description:
        "Integracje z kurierami: InPost (Paczkomaty, Kurier), DPD, DHL, GLS, Pocztex, UPS, FedEx. Automatyczne listy przewozowe, tracking, etykiety zbiorcze. Wdrożenia w Baselinker.",
      path: PATH,
    }),
  component: () => (
    <PlatformPage data={logistykaKurierzy} path={PATH} breadcrumbCategory="Integracje" />
  ),
});
